import React,{useState} from 'react';
import { FaTrophy, FaMedal, FaNewspaper,    FaFlask, FaChalkboardTeacher, FaUserGraduate, FaImages } from 'react-icons/fa';
import "../../Component/Gallery.css"

const Archivements = () => {
  
    const toppers = [
        {
          id: 1,
          name: "Aarav Sharma",
          class: "Class XII",
          score: "98.4%",
          achievement: "Secured state rank 3 in CBSE Board 2023",
          image: "assets/images/Team/teacher_1.webp"
        },
        {
          id: 2,
          name: "Priya Patel",
          class: "Class X",
          score: "97.8%",
          achievement: "National Science Olympiad Gold Medalist",
          image: "assets/images/Team/teacher_2.webp"
        },
        {
          id: 3,
          name: "Rohan Mehta",
          class: "Class XII",
          score: "99.2%",
          achievement: "Perfect score in Mathematics",
          image: "assets/images/Team/teacher_4.webp"
        }
      ];
      const pressCoverage = [
        {
          id: 1,
          outlet: "The Education Times",
          headline: "Innovative teaching methods set new benchmark in STEM education",
          date: "2023-03-15",
          articleUrl: "https://example.com/article1",
          imageUrl: `https://images.pexels.com/photos/669610/pexels-photo-669610.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1`
          
        },
        {
            id: 2,
            outlet: "National Herald Times",
            headline: "School wins award for best digital learning initiative",
            date: "2023-05-22",
            articleUrl: "https://example.com/article2",
            imageUrl: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHByZXNzJTIwY29uZmVyZW5jZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=600&q=60"
        },
        {
          id: 3,
          outlet: "Child Education Magazine",
          headline: "How this school is revolutionizing early childhood education",
          date: "2023-08-10",
          articleUrl: "https://example.com/article3",
          imageUrl: `https://images.pexels.com/photos/669610/pexels-photo-669610.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1`
        }
      ];

      const teacherRecognitions = [
        {
          id: 1,
          title: "National Teaching Excellence Award",
          desc: "Awarded by the Ministry of Education for innovative pedagogy",
          info: "Received for developing the 'Math Through Nature' curriculum that improved student engagement by 40%",
          image: "assets/images/Team/teacher_1.webp",
          year: 2023,
          category: "Innovation"
        },
        {
          id: 2,
          title: "Global Educator Prize Finalist",
          desc: "Top 50 finalist among 12,000 international nominations",
          info: "Recognized for STEM outreach programs in rural communities",
          image: "assets/images/Team/teacher_2.webp",
          year: 2022,
          category: "Community Service"
        },
        {
          id: 3,
          title: "Best ICT Integration Award",
          desc: "State-level recognition for technology integration in classrooms",
          info: "Developed virtual lab simulations used by 200+ schools nationwide",
          image: "assets/images/Team/teacher_3.webp",
          year: 2023,
          category: "Technology"
        },
        {
          id: 4,
          title: "Lifetime Achievement Award",
          desc: "25 years of service in science education",
          info: "Mentored 15 state-level science olympiad winners",
          image: "assets/images/Team/teacher_4.webp",
          year: 2024,
          category: "Leadership"
        },
        {
          id: 5,
          title: "Student's Choice Award",
          desc: "Voted by students as most inspiring teacher",
          info: "Maintained 98% positive feedback over 5 consecutive years",
          image: "assets/images/Team/teacher_5.webp",
          year: 2023,
          category: "Teaching Excellence"
        },
        {
            id: 5,
            title: "Topper Choice Award",
            desc: "Voted by students as most inspiring teacher",
            info: "Maintained 78% positive feedback over 5 consecutive years",
            image: "assets/images/Team/teacher_6.webp",
            year: 2023,
            category: "Sports Coach"
          }
      ];

      const successStories = [
        {
          id: 1,
          name: "Dr. Priya Patel",
          batch: "Batch of 2010",
          education: "PhD in Neuroscience, Harvard",
          achievement: "Leading Alzheimer's research at NIH, published 30+ papers",
          image:"assets/images/banner1.jpg"
        },
        {
          id: 2,
          name: "Rahul Verma",
          batch: "Batch of 2015",
          education: "MS in Computer Science, MIT",
          achievement: "AI Research Lead at Google Brain, developed TensorFlow 3.0 research at NIH +1 ",
          image: "assets/images/banner2.jpg"
        },
        {
          id: 3,
          name: "Ananya Desai",
          batch: "Batch of 2018",
          education: "MBA, Stanford University",
          achievement: "Founder of EdTech startup valued at $50M developed TensorFlow 3.0, New terms implet",
          image:"assets/images/banner4.jpg"
        }
      ];

      const olympiadData = [
        {
          id: 1,
          name: "SOF IMO",
          title: "International Mathematics Olympiad",
          icon: <FaMedal size={24} />,
          gold: 5,
          silver: 12,
          bronze: 18,
          image: "assets/images/Testimonial/testimonial_1.webp" // or image URL
        },
        {
          id: 2,
          name: "SOF ISO",
          title: "International Science Olympiad",
          icon: <FaMedal size={24} />,
          gold: 4,
          silver: 10,
          bronze: 15,
          image: "assets/images/Testimonial/testimonial_3.webp"
        },
        {
            id: 3,
            name: "SOF ISO",
            title: "International Science Olympiad",
            icon: <FaMedal size={24} />,
            gold: 4,
            silver: 10,
            bronze: 15,
            image: "assets/images/Testimonial/testimonial_4.webp"
          }, {
            id: 4,
            name: "SOF ISO",
            title: "International Science Olympiad",
            icon: <FaMedal size={24} />,
            gold: 4,
            silver: 10,
            bronze: 15,
            image: "assets/images/Testimonial/testimonial_6.webp"
          }
      ];
      const images = [
        "assets/images/Courses/courses_1.webp",
        "assets/images/Courses/courses_2.webp",
        "assets/images/Courses/courses_3.webp",
        "assets/images/Courses/courses_4.webp",
        "assets/images/Courses/courses_5.webp",
        "assets/images/Courses/courses_6.webp",
        "assets/images/Courses/courses_2.webp",
        "assets/images/Courses/courses_3.webp"
      ];

      const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (index) => setSelectedImage(index);
  const closeModal = () => setSelectedImage(null);
  const showPrev = () =>
    setSelectedImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const showNext = () =>
    setSelectedImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));


  return (
    <div>

        <section className="Subpage_Hero bg-gradient-primary">
        <div className="container py-5">
          <div className="text-start text-white" data-aos="fade-up">
            <h1 className=" display-4 fw-bold">Toppers & Archivements</h1>
            <p className="lead">
              A vibrant ecosystem fostering holistic development and safety
            </p>
          </div>
        </div>
      </section>


    <div className="highlights-page">

      {/* Topper Highlights */}
      <section className="py-5 bg-gradient-light">
  <div className="container">
    <div className="section-header text-center mb-5">
            <h2 className="mt-3 color ">Topper Highlights</h2>
      <p className="lead text-muted mx-auto" style={{maxWidth: "600px"}}>Celebrating our top performers who set new benchmarks in academic achievement</p>
    </div>

    <div className="row g-4 justify-content-center">
      {toppers.map((topper, index) => (
        <div className="col-lg-4 col-md-6" key={topper.id || index} data-aos="fade-up" data-aos-delay={`${index * 100}`}>
          <div className="card border-0 rounded-4 overflow-hidden shadow-hover " style={{transition: "all 0.3s ease"}}>
            <div className="position-relative">
              <img
                src={topper.image}
                className="img-fluid w-100"
                alt={topper.name}
                style={{height: "280px", objectFit: "cover"}}
              />
              <div className="position-absolute bottom-0 start-0 w-100 p-3 bg-gradient-dark-top hover-text-light">
              <h5 className="text-white mb-0 hover-target">{topper.name}</h5>
              <p className="text-white-50 mb-0 small hover-target">{topper.class}</p>
            </div>

            </div>

            <div className="card-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div className="bgcolor1 bg-opacity-10 px-3 py-1 rounded-pill">
                  <span className="text-white fw-bold">{topper.score}</span>
                </div>
              </div>
              <p className="card-text mb-3">{topper.achievement}</p>
              <div className="d-flex justify-content-center gap-2">
                <a href="#" className="btn btn-sm btn-outline-secondary  rounded-pill px-3">
                  <i className="bi bi-eye-fill me-1"></i> Profile
                </a>
                <a href="#" className="btn btn-sm custom-hover rounded-pill px-3">
                  <i className="bi bi-award-fill me-1"></i> Achievements
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className="text-center mt-5">
      <a href="#" className="btn custom-hover px-4 py-2 rounded-pill">
        View All Achievers <i className="bi bi-arrow-right ms-2"></i>
      </a>
    </div>
  </div>
      </section>

      {/* Olympiad Achievements */}
      <section className="py-5">
  <div className="container">
    <div className="section-header text-center mb-5">
      {/* <FaMedal className="section-icon text-info" size={48} /> */}
      <h2 className="mt-3 color">Olympiad Achievements</h2>
      <p className="text-muted">Celebrating our champions in national and international competitions</p>
    </div>
    
    <div className="row g-4">
      {olympiadData.map((item, index) => (
        <div className="col-md-6 col-lg-3 mb-4" key={item.id} data-aos="zoom-in-right" data-aos-delay={`${index * 100}`}>
          <div className="card h-100 border-0 shadow-hover" style={{
            transition: 'transform 0.3s ease',
            borderRadius: '12px',
            overflow: 'hidden'
          }}>
            {/* Card Header with Image */}
            <div className="position-relative pt-4 px-4">
              <div className="mx-auto position-relative" style={{width: '120px', height: '120px'}}>
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="rounded-circle w-100 h-100 object-fit-cover border border-4 border-white shadow-sm"
                />
                {item.icon && (
                  <div className="position-absolute bottom-0 end-0 bg-warning text-white rounded-circle d-flex align-items-center justify-content-center" 
                       style={{
                         width: '36px',
                         height: '36px',
                         border: '3px solid white'
                       }}>
                    {item.icon}
                  </div>
                )}
              </div>
            </div>
            
            {/* Card Body */}
            <div className="card-body text-center px-4 pt-0 pb-4 d-flex flex-column">
              <h5 className="card-title mb-1 fw-semibold" style={{color: '#2c3e50', fontSize: '1.1rem'}}>
                {item.name}
              </h5>
              <p className="text-muted mb-3 small">{item.title}</p>

              {/* Achievements List */}
              <div className="achievement-list mt-auto">
                <div className="d-flex align-items-center justify-content-between mb-2 px-3 py-2 rounded" style={{background: 'rgba(52, 152, 219, 0.1)'}}>
                  <span className="d-flex align-items-center">
                    <span className="medal-icon" style={{fontSize: '1.2rem'}}>🥇</span>
                    <span className="ms-2 small">Gold</span>
                  </span>
                  <span className="badge bg-warning bg-opacity-20 text-white fw-bold">0{item.gold}</span>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-2 px-3 py-2 rounded" style={{background: 'rgba(189, 195, 199, 0.1)'}}>
                  <span className="d-flex align-items-center">
                    <span className="medal-icon" style={{fontSize: '1.2rem'}}>🥈</span>
                    <span className="ms-2 small">Silver</span>
                  </span>
                  <span className="badge bg-secondary bg-opacity-20 text-white fw-bold">{item.silver}</span>
                </div>

                <div className="d-flex align-items-center justify-content-between px-3 py-2 rounded" style={{background: 'rgba(231, 76, 60, 0.1)'}}>
                  <span className="d-flex align-items-center">
                    <span className="medal-icon" style={{fontSize: '1.2rem'}}>🥉</span>
                    <span className="ms-2 small">Bronze</span>
                  </span>
                  <span className="badge bg-danger bg-opacity-20 text- fw-bold">{item.bronze}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
     </section>

      {/* Press Coverage */}
      <section className="py-5 ">
  <div className="container">
    {/* Preserved Section Header */}
    <div className="section-header text-center mb-5">
            {/* <FaNewspaper className="section-icon text-danger" size={48} /> */}
            <h2 className="mt-3 color ">Press Coverage</h2>
            <p className="text-muted">When media highlighted our achievements</p>
          </div>

    <div className="row g-4">
      {pressCoverage.map((coverage, index) => (
        <div className="col-lg-4 col-md-6" key={coverage.id || index} data-aos="fade-up" data-aos-delay={`${index * 100}`}>
          <div className="card h-100 border-0 shadow-sm overflow-hidden hover-lift transition-all">
            {/* Image with overlay */}
            <div className="position-relative">
              <img 
                src={coverage.imageUrl} 
                className="card-img-top object-fit-cover" 
                alt={coverage.outlet}
                style={{height: "200px"}}
              />
              <div className="position-absolute top-0 end-0 m-3">
                <span className="badge bg-white text-dark rounded-pill px-3 py-1 shadow-sm">
                  <i className="bi bi-newspaper me-1"></i> {coverage.type || 'Feature'}
                </span>
              </div>
            </div>
            
            {/* Card Body */}
            <div className="card shadow-sm border-0 h-100">
  <div className="card-body d-flex flex-column px-4 py-3">

    {/* Outlet Logo & Name */}
    <div className="d-flex align-items-center mb-3">
      {/* Uncomment if logo is available */}
      {/* <img 
        src={coverage.outletLogo} 
        alt={`${coverage.outlet} logo`} 
        className="me-2"
        style={{ width: "28px", height: "28px", objectFit: "contain" }}
      /> */}
      <h5 className="card-title mb-0 fw-semibold text-dark">{coverage.outlet}</h5>
    </div>

    {/* Headline */}
    <p className="card-text text-muted  mb-4">
      “{coverage.headline}”
    </p>

    {/* Footer: Date + Button */}
    <div className="mt-auto">
      <div className="d-flex justify-content-between align-items-center border-top pt-3">
        <small className="text-orange d-flex align-items-center">
          <i className="bi bi-calendar me-2"></i>
          {new Date(coverage.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          })}
        </small>

        <a 
          href={coverage.url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn btn-sm rounded-circle bgcolor text-white shadow-sm d-flex align-items-center justify-content-center"
          style={{ width: "36px", height: "36px" }}
          aria-label="Read article"
        >
          <i className="bi bi-arrow-right fs-5"></i>
        </a>
      </div>
    </div>

  </div>
</div>

          </div>
        </div>
      ))}
    </div>

    {/* Optional View All Button */}
    <div className="text-center mt-5 d-none">
      <button className="btn btn-outline-primary px-4">
        View All Media Coverage <i className="bi bi-arrow-right ms-2"></i>
      </button>
    </div>
  </div>
</section>

      {/* Teacher Recognitions */}
      <section className="py-5">
        <div className="container">
          <div className="section-header text-center mb-5">
            {/* <FaChalkboardTeacher className="section-icon text-success" size={48} /> */}
            <h2 className="mt-3 color">Teacher Recognitions</h2>
            <p className="text-muted">Honoring our educators' exceptional contributions</p>
          </div>
          <div className="row g-4">
  {teacherRecognitions.map((teacher) => (
    <div
      className="col-md-6 col-lg-4"
      key={teacher.id}
      data-aos="zoom-in-left"
      data-aos-delay={`${teacher.id * 160}`}
      data-aos-duration="1000"
    >
      <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
        
        {/* Card Image */}
        <div
          className="card-img-top bg-light d-flex align-items-center justify-content-center"
          style={{
            height: "240px",
            backgroundImage: teacher.image ? `url(${teacher.image})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
           {/* <div className="position-absolute  end-0 bottom-0 m-3">
                <span className="badge bg-white text-dark rounded-pill px-3 py-1 shadow-sm">
                  <i className="bi bi-newspaper me-1"></i> {teacher.category || 'Feature'}
                </span>
              </div> */}
          {!teacher.image && (
            <i className="fas fa-user-tie fa-4x text-muted"></i>
          )}
          <div className="position-absolute end-0 top-0 m-3">
    <span className="badge bg-white text-dark rounded-pill px-3 py-1 shadow-sm">
      <i className="bi bi-newspaper me-1"></i> {teacher.category || 'Feature'}
    </span>
  </div>
        </div>

        {/* Card Content */}
        <div className="card-body d-flex flex-column px-4 py-3">
          {/* <span className="badge rounded-pill bg-primary mb-2" style={{ fontSize: "0.8rem" }}>
            {teacher.category}
          </span> */}

          <h5 className="card-title fw-semibold text-dark mb-1">{teacher.title}</h5>
          <p className="text-muted small mb-2">{teacher.desc}</p>

          <p className="card-text text-body small flex-grow-1">{teacher.info}</p>
        </div>

        {/* Footer */}
        <div className="card-footer bg-white border-0 px-4 pb-3 pt-0">
          <hr className="my-2" />
          <small className="text-muted">
            <i className="bi bi-award me-1"></i> Awarded: {teacher.year}
          </small>
        </div>
      </div>
    </div>
  ))}
</div>

        </div>
      </section>

      {/* Alumni Success */}
      <section className="py-5 bg-">
        <div className="container">
          <div className="section-header text-center mb-5">
            {/* <FaUserGraduate className="section-icon text-primary" size={48} /> */}
            <h2 className="h2 fw-bold display-5 mt-3">Alumni Success Stories</h2>
            <p className="text-muted">Where our students are making an impact globally</p>
          </div>
          <div className="row g-4">
  {successStories.map((alumni, index) => (
    <div className="col-md-4" key={alumni.id} data-aos="zoom-in-right" data-aos-delay={`${index * 100}`}>
      <div className="card h-100 border-0 shadow-sm hover-lift">
        {/* Image Container */}
        <div className="card-img-top bg-light position-relative" style={{ height: "250px" }}>
          <img 
            src={alumni.image} 
            className="w-100 h-100 object-fit-cover"
            alt={`${alumni.name}, ${alumni.batch}`}
            onError={(e) => {
              e.target.src = '/default-alumni.jpg';
              e.target.className = 'w-100 h-100 object-fit-contain p-4';
              e.target.onerror = null;
            }}
          />
          <div className="position-absolute bottom-0 start-0 w-100 p-3 bg-gradient-dark-top">
            <p className="text-white mb-0 small">{alumni.batch}</p>
          </div>
        </div>

        {/* Card Content */}
        <div className="card-body d-flex flex-column">
          <h5 className="card-title text-center fw-semibold">{alumni.name}</h5>

          <div className="d-flex justify-content-center mb-3">
    <span className="badge bg-light text-dark border rounded-pill px-3 py-2 d-flex align-items-center">
      <i className="fas fa-graduation-cap text-primary me-2"></i>
      <span>{alumni.education}</span>
    </span>
  </div>

          <div className="mb-3 flex-grow-1">
            <p className="card-text text-center mx-3 small">
              <i className="bi bi-quote text-primary fs-4 me-2 align-top"></i>
              {alumni.achievement}
            </p>
          </div>

          <div className="mt-auto text-center">
            <button className="btn btn-sm custom-hover rounded-pill  px-3 mx-2">
               Read  <i className="bi bi-arrow-right ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

{/* Add this CSS */}
<style jsx>{`
  .hover-lift {
    transition: all 0.3s ease;
  }
  .hover-lift:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
  }
  .bg-gradient-dark-top {
    background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);
  }
`}</style>
        </div>
      </section>

      <section className="gallery-section">
      <div className="container">
        <h2 className="color">Life at DNET</h2>
        <div className="gallery-grid collage-style">
          {images.map((image, index) => (
            <div
              key={index}
              className={`gallery-item item-${index + 1}`}
              onClick={() => openModal(index)}
              data-aos="zoom-in-left"
              data-aos-delay={`${index * 160}`}
              data-aos-duration="1000"
            >
              <img src={image} alt={`Campus Life ${index + 1}`} />
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-primary">View Full Gallery</button>
        </div>
      </div>

      {selectedImage !== null && (
        <div className="image-modal" onClick={closeModal}>
          <span className="close-btn" onClick={closeModal}>
            &times;
          </span>
          <img
            src={images[selectedImage]}
            className="modal-img"
            alt="Expanded View"
          />
          <button
            className="nav-btn prev"
            onClick={(e) => {
              e.stopPropagation();
              showPrev();
            }}
          >
            &#10094;
          </button>
          <button
            className="nav-btn next"
            onClick={(e) => {
              e.stopPropagation();
              showNext();
            }}
          >
            &#10095;
          </button>
        </div>
      )}
    </section>



      {/* Event Gallery */}
      <section className="py-5 d-none">
        <div className="container">
          <div className="section-header text-center mb-5">
            <FaImages className="section-icon text-warning" size={48} />
            <h2 className="mt-3">Gallery of Recent Events</h2>
            <p className="text-muted">Capturing memorable moments from our campus</p>
          </div>
          <div className="row g-3">
            {[1,2,3,4,5,6,7,8].map((item, index) => (
              <div className="col-6 col-md-4 col-lg-3" key={index}>
                <div className="gallery-item overflow-hidden rounded-3 shadow-sm">
                  <img 
                    src={`https://source.unsplash.com/random/400x300/?school,event&sig=${index}`} 
                    className="img-fluid w-100 hover-zoom" 
                    alt="Event" 
                  />
                  <div className="gallery-caption p-2">
                    <small className="d-block text-truncate">Annual Science Fair 2023</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <button className="btn btn-primary">View Full Gallery</button>
          </div>
        </div>
      </section>

     
    </div>


    </div>
  )
}

export default Archivements
